// Libraries
import styled from 'styled-components'

// Components
import { Aligner, Button } from 'heeds-ds'

export const AlignRow = styled(Aligner).attrs(() => ({
  flex: 'column',
}))`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    flex-direction: row;
    gap: 2.4rem;
  }
`

export const ButtonContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.surface.default};
  display: flex;
  justify-content: space-between;
  padding: 80px 39px;
  width: 100%;
  button {
    margin: 0;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    background-color: transparent;
    padding: 40px 0;
  }
`

export const CancelButton = styled(Button).attrs(() => ({
  cancel: true,
  size: 'small',
  variation: 'outlined',
}))``

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}px) {
    gap: 24px;
    padding: 24px;
  }
`
